export interface ExitReviewKeyArguments {
  approvalId: string;
  currentStatus: string;
  roleName: string;
}

/**
 * Hierarchical query-key factory for the Workbench exit review (dropdown options +
 * Review Advances figures). Mirrors the other feature key factories so cache
 * invalidation stays predictable: invalidating `all` flushes every exit-review
 * query, `details()` flushes all exit-review reads, and
 * `detail({ approvalId, currentStatus, roleName })` flushes a single lookup. Never
 * write a literal key array outside this module — the factory IS the schema.
 *
 * Keyed on all three inputs the BFF requires (approvalId path + currentStatus &
 * roleName query params), so the review re-fetches whenever any of them changes.
 */
export const exitReviewKeys = {
  all: ["exitReview"] as const,
  details: () => [...exitReviewKeys.all, "detail"] as const,
  detail: (arguments_: ExitReviewKeyArguments) => [...exitReviewKeys.details(), arguments_] as const,
};
